import { fork } from 'redux-saga/effects';
import bookDetailsSagas from './pages/bookDetails/Sagas';
import activationCodeSagas from './pages/activation/Sagas';
import addImageSaga from './components/modals/addImage/Sagas';
import addListsModalSagas from './components/modals/addListModal/Sagas';
import answerModalSagas from './components/modals/createAnswer/Sagas';
import appPushNotificationSagas from './components/appPushNotification/Sagas';
import chapterDetailsSagas from './pagesNext/chapterDetails/Sagas';
import chooseProfileImageModalSagas from './components/modals/chooseProfileImageModal/Sagas';
import couponReaderSagas from './pages/couponReader/Sagas';
import createListSagas from './pages/createList/Sagas';
import exerciseNextSagas from './pagesNext/exercise/Sagas';
import exerciseSagas from './pages/exercises/Sagas';
import folderDetailsSagas from './pages/folderDetails/Sagas';
import forgotPasswordSagas from './pages/forgotPassword/Sagas';
import groupDetailsSagas from './pages/groupDetails/Sagas';
import groupOverviewSagas from './pages/groupOverview/Sagas';
import languageSelectorSagas from './components/languageSelector/Sagas';
import listDetailsSagas from './pages/listDetails/Sagas';
import listsSagas from './pages/lists/Sagas';
import methodDetailsSagas from './pages/methodDetails/Sagas';
import notificationsSagas from './components/notifications/Sagas';
import onboardingModalSagas from './components/modals/onboarding/Sagas';
import packagesSagas from './pages/packages/Sagas';
import parentRequestModalSagas from './components/modals/parentRequest/Sagas';
import parentShop from './pages/publicShop/Sagas';
import payInvoiceModalSagas from './components/modals/payInvoice/Sagas';
import paymentSagas from './pages/successPayment/Sagas';
import playButtonSagas from './components/playButton/Sagas';
import profileSettingsSagas from './pages/profileSettings/Sagas';
import publicProfileSagas from './pages/publicProfile/Sagas';
import qaSagas from './pagesNext/qA/Sagas';
import questionModalSagas from './components/modals/createQuestion/Sagas';
import quizDetailsSagas from './pagesNext/quizDetails/Sagas';
import reportModalSagas from './components/modals/reportModal/Sagas';
import resetPasswordSagas from './pages/resetPassword/Sagas';
import resultDetailsSagas from './pages/resultDetails/Sagas';
import searchDetailsSagas from './pages/searchDetails/Sagas';
import searchSagas from './pages/search/Sagas';
import selectBookSagas from './pagesNext/selectBook/Sagas';
import sharedSagas from './pagesNext/shared/Sagas';
import shopSagas from './pages/shop/Sagas';
import sidebarSagas from './components/sideBar/Sagas';
import signInSagas from './pages/signIn/Sagas';
import signUpSagas from './pages/signUp/Sagas';
import subjectDetailsSagas from './pagesNext/subjecDetails/Sagas';
import switchPackageModalSagas from './components/modals/switchPackage/Sagas';
import manageQuizModalSagas from './components/modals/manageQuizModal/Sagas';
import testResultsSagas from './pagesNext/testResults/Sagas';
import topicDetailsSagas from './pagesNext/topicDetails/Sagas';
import resultTabSagas from './pagesNext/resultTab/Sagas';
import quizEditorSaga from './components/quiz/Sagas';
import liveBattleSaga from './pagesNext/live/Sagas';
import examDetailsSaga from './pagesNext/examDetails/Sagas';
import packageCancellationSagas from './components/packageCancellation/Sagas';
import offerSaga from './pages/offer/Sagas';
import streaksBarSaga from './components/streaksBar/Sagas';
import achievementsModalSaga from './components/modals/achievements/Sagas';
import tutoringSharedSaga from './tutoring/shared/Sagas';
import songAiSaga from './pages/studySong/Sagas';
import lessonSagas from './tutoring/pages/lesson/Sagas';
import lessonOverviewSagas from './tutoring/pages/lessonOverview/Sagas';
import lessonDetailsSagas from './tutoring/pages/lessonDetails/Sagas';
import lessonRequestSagas from './components/modals/lessonRequest/Sagas';
import addGroupManagerSagas from './pages/groupDetails/modals/addManager/Sagas';
import selectOwnerModalSagas from './pages/groupDetails/modals/selectOwner/Sagas';
import npsModalSagas from './components/modals/nps/Sagas';
import licenseInviteLinkModalSaga from './components/modals/licenseInviteLinkModal/Sagas';
import addWysiwygImageModalSaga from './components/wysiwyg/addImage/Sagas';
import addWysiwygAudioModalSaga from './components/wysiwyg/addAudio/Sagas';
import learningPathSagas from './components/learningPath/Sagas';
import shareModalSaga from './components/modals/share/Sagas';
import aiChatSaga from './components/modals/chat/Sagas';
import renewalSubscriptionModalSaga from './components/modals/renewalSubscription/Sagas';

const sagas = [
	activationCodeSagas,
	addImageSaga,
	addListsModalSagas,
	quizEditorSaga,
	answerModalSagas,
	appPushNotificationSagas,
	bookDetailsSagas,
	chapterDetailsSagas,
	chooseProfileImageModalSagas,
	couponReaderSagas,
	createListSagas,
	exerciseNextSagas,
	exerciseSagas,
	folderDetailsSagas,
	forgotPasswordSagas,
	groupDetailsSagas,
	groupOverviewSagas,
	languageSelectorSagas,
	listDetailsSagas,
	listsSagas,
	liveBattleSaga,
	manageQuizModalSagas,
	methodDetailsSagas,
	notificationsSagas,
	onboardingModalSagas,
	packagesSagas,
	packageCancellationSagas,
	parentRequestModalSagas,
	parentShop,
	payInvoiceModalSagas,
	paymentSagas,
	playButtonSagas,
	profileSettingsSagas,
	publicProfileSagas,
	qaSagas,
	questionModalSagas,
	quizDetailsSagas,
	reportModalSagas,
	resetPasswordSagas,
	resultDetailsSagas,
	resultTabSagas,
	searchDetailsSagas,
	searchSagas,
	selectBookSagas,
	sharedSagas,
	shopSagas,
	sidebarSagas,
	signInSagas,
	signUpSagas,
	subjectDetailsSagas,
	switchPackageModalSagas,
	testResultsSagas,
	topicDetailsSagas,
	examDetailsSaga,
	offerSaga,
	streaksBarSaga,
	achievementsModalSaga,
	tutoringSharedSaga,
	songAiSaga,
	lessonSagas,
	lessonOverviewSagas,
	lessonDetailsSagas,
	lessonRequestSagas,
	addGroupManagerSagas,
	selectOwnerModalSagas,
	npsModalSagas,
	addWysiwygImageModalSaga,
	addWysiwygAudioModalSaga,
	licenseInviteLinkModalSaga,
	learningPathSagas,
	shareModalSaga,
	aiChatSaga,
	renewalSubscriptionModalSaga,
];

export default function* rootSaga() {
	for (const saga of sagas) {
		yield fork(saga);
	}
}
